import React from 'react';
import { getidtimestamp } from "../../util/global";
import { customer, subscription, deliveryitem } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: customer;
  subscriptions: subscription[];
  payments: any[];
  deliveries: deliveryitem[];
}

// CustomerActivityLog: read-only modal listing one customer's subscriptions,
// payments and deliveries newest first, with registration at the bottom.
// Rendered only while showmodal === "showcustomeractivitylog"; the parent fetches the data.
const CustomerActivityLog: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  subscriptions,
  payments,
  deliveries
}) => {
  if (showmodal !== "showcustomeractivitylog") return null;

  const events = [
    ...subscriptions.map(item => ({
      date: getidtimestamp(item._id!),
      type: "subscription",
      detail: item.label + ", " + item.items.reduce((sum, it) => sum + Number(it.quantity), 0) + " items per delivery",
      status: item.status
    })),
    ...payments.map(item => ({
      date: item.createdat,
      type: "payment",
      detail: "₹" + item.totalamount + ", " + (item.gatewaypaymentid || '-'),
      status: item.status
    })),
    ...deliveries.map(item => ({
      date: item.deliverydate,
      type: "delivery",
      detail: '-',
      status: item.status
    }))
  ].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  events.push({ date: formdata.timestamp, type: "registration", detail: formdata.email, status: formdata.status });

  const rows = events.map((item, i) => (
    <tr key={i}>
      <td>{item.date ? item.date.split('T')[0] : '-'}</td>
      <td>{item.type}</td>
      <td>{item.detail}</td>
      <td><span className={`status-badge ${item.status}`}>{item.status || '-'}</span></td>
    </tr>
  ));

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata.name}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <table className="grid">
            <thead>
              <tr>
                <th>date</th>
                <th>type</th>
                <th>detail</th>
                <th>status</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomerActivityLog;
